import { render, staticRenderFns } from "./SdkRecipients.vue?vue&type=template&id=1d2eb9fa&"
import script from "./SdkRecipients.vue?vue&type=script&lang=js&"
export * from "./SdkRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d2eb9fa')) {
      api.createRecord('1d2eb9fa', component.options)
    } else {
      api.reload('1d2eb9fa', component.options)
    }
    module.hot.accept("./SdkRecipients.vue?vue&type=template&id=1d2eb9fa&", function () {
      api.rerender('1d2eb9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/SDK/SdkRecipients.vue"
export default component.exports